<template>
  <div class="cus-nav">
    <ul class="ul_top">
      <li><a @click="handleClick('index')">首页</a></li>
      <li><a @click="handleClick('systemList')">办学系统</a></li>
      <li>
        <a
          :class="curPath == '/noticeList' ? 'activite' : ''"
          @click="handleClick('noticeList')"
          >通知公告</a
        >
      </li>
      <li>
        <a
          :class="curPath == '/caseList' ? 'activite' : ''"
          @click="handleClick('caseList')"
          >案例展示</a
        >
      </li>
      <li>
        <a
          :class="curPath == '/equipList' ? 'activite' : ''"
          @click="handleClick('equipList')"
          >仪器详例</a
        >
      </li>
      <li>
        <a
          :class="curPath == '/policyList' ? 'activite' : ''"
          @click="handleClick('policyList')"
          >政策文件</a
        >
      </li>
      <li><a @click="handleClick('sxyj')">书香燕京</a></li>
      <li><a @click="handleClick('jspx')">教师培训</a></li>
    </ul>
  </div>
</template>

<script>
import { getGwUrlSxyj, getGwUrlJspx } from "@/api/common";
export default {
  name: "CusNav",
  data() {
    return {
      //curPath:''
    };
  },
  created() {
    // console.log(this.$route)
    // this.curPath = this.$route.path
  },
  computed: {
    curPath() {
      //console.log(this.$route.path);
      return this.$route.path;
    },
  },
  methods: {
    async getGwUrlSxyj() {
      const res = await getGwUrlSxyj();
      window.open(res.data.gwUrl, "__blank");
    },
    async getGwUrlJspx() {
      const res = await getGwUrlJspx();
      window.open(res.data.gwUrl, "__blank");
    },
    handleClick(type) {
      switch (type) {
        case "systemList":
          this.$router.push({ path: "/systemList" });
          break;
        case "equipList":
          this.$router.push({ path: "/equipList" });
          break;
        case "login":
          this.$router.push({ path: "/login" });
          break;
        case "caseList":
          this.$router.push({ path: "/caseList" });
          break;
        case "noticeList":
          this.$router.push({ path: "/noticeList" });
          break;
        case "policyList":
          this.$router.push({ path: "/policyList" });
          break;
        case "index":
          this.$router.push({ path: "/" });
          break;
        case "sxyj":
          this.getGwUrlSxyj();
          break;
        case "jspx":
          this.getGwUrlJspx();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cus-nav {
  width: 100%;
  height: 47px;
  display: flex;
  justify-content: center;
  background: #bd1a2d;
  border-top: 1px solid #000;
  .ul_top {
    width: 1400px;
    display: flex;
    align-items: center;
    margin-left: 128px;
    > li {
      width: 147px;
      font-size: 22px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      > a {
        display: flex;
        justify-content: center;
      }
    }
  }
}
.cus-nav a {
  display: block;
  color: #ffffff;
  text-decoration: none;
  width: 147px;
  line-height: 47px;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.cus-nav a:hover {
  color: #f5d389;
  background: #bd1a2d;
  background-image: url(../assets/nav-bc.png);
  background-size: 147px 47px;
}
.activite {
  color: #f5d389;
  background: #bd1a2d;
  background-image: url(../assets/nav-bc.png);
  background-size: 147px 47px;
}
</style>


// WEBPACK FOOTER //
// src/components/CusNav.vue